// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eMkbH7uSfdMQqts28dcQ {
  height: 1.875rem;
  background-repeat: repeat no-repeat;
  background-size: cover;
  background-color: var(--white);
}

@media only screen and
  (min-width: 1280px) {
  .eMkbH7uSfdMQqts28dcQ {
    background-size: contain;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/HeaderDecoration/HeaderDecoration.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAY;EACZ,mCAAmC;EACnC,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".headerDecoration {\n  height: 30px;\n  background-repeat: repeat no-repeat;\n  background-size: cover;\n  background-color: var(--white);\n}\n\n@media (--desktop-large) {\n  .headerDecoration {\n    background-size: contain;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerDecoration": `eMkbH7uSfdMQqts28dcQ`
};
export default ___CSS_LOADER_EXPORT___;
